// extracted by mini-css-extract-plugin
export default {"container":"PendingValue_container__88UJQ","rightAlign":"PendingValue_rightAlign__A7dXH","value":"PendingValue_value__I-qe-"};